import { MetricDetails } from '../../../../api/metrics/types';
import { SQLFilters } from '../../../../api/types';
import { MetricId } from '../../../../api/types-graphql';
import { MetricIdType, SingleValueTimeSelection } from '../../../../types';
import { LanguageString } from '../../dashboards/types';
import { TitleConfig } from '../../ui-components/data-viz-ui/charts/common/common-chart-types';
import { ExternalChartComponentProps } from '../common/types';

export type MultiMetricComparisonVizExternalProps = ExternalChartComponentProps;

export interface MultiMetricComparisonVizQuery {
  metric: MetricIdType;
  /**
   * Optional display label for the metric.
   * If not provided, the metric's translated name will be used.
   */
  label?: LanguageString;
}

export interface MultiMetricComparisonVizConfig {
  title?: LanguageString;
  timeSelection: SingleValueTimeSelection;
  queries: MultiMetricComparisonVizQuery[];
  filters?: SQLFilters;
  chartColors?: string[];
  /**
   * When true, renders bars horizontally (metrics on Y-axis, values on X-axis).
   */
  isHorizontal?: boolean;
}

/**
 * Represents the value for a single metric in the comparison.
 */
export interface MultiMetricComparisonMetricValue {
  metric: MetricIdType;
  /**
   * Display label for the metric (translated name or custom label).
   */
  label: string;
  /**
   * The aggregate value for this metric.
   */
  value: number;
  metricSql: string | null;
}

export interface MultiMetricComparisonVizDataResponse {
  metricValues: MultiMetricComparisonMetricValue[];
}

export interface MultiMetricComparisonVizData {
  dataResponse: MultiMetricComparisonVizDataResponse;
  titleConfig: TitleConfig;
  metricDetails: Partial<Record<MetricId, MetricDetails>>;
  metricDisplayValues: Partial<Record<MetricId, string>>;
  chartColors?: string[];
  isHorizontal?: boolean;
}

export enum MultiMetricComparisonVizViews {
  BAR_CHART = 'bar-chart',
  TABLE_VIEW = 'table-view',
}
